import { Heading, MetaPill } from '@doist/marketist'

import cn from 'clsx'

import css from './TagList.module.css'

type Props = {
    title: string
    labels?: string[]
    children?: React.ReactNode
    className?: string
}

function TagList({ title, labels = [], children, className, ...rest }: Props) {
    return (
        <div className={cn(css.tagList, className)} {...rest}>
            <Heading level="3" size="minor-base" weight="semibold">
                {title}
            </Heading>
            <ul className={css.tagGroup}>
                {labels.map((label) => (
                    <MetaPill size="small" key={label}>
                        {label}
                    </MetaPill>
                ))}
            </ul>
            {children}
        </div>
    )
}

export { TagList }
export type { Props }
